export default {
  data(){
    return {
    }
  },
  methods: {
    _listenerPanMove(he){
      if (this._canUserPanSlider()) return
      
      let doPanDown = he.changedPointers[0].movementY > 0; 
      let doPanUp = he.changedPointers[0].movementY < 0; 
      let doPanRight = he.changedPointers[0].movementX > 0; 
      let doPanLeft = he.changedPointers[0].movementX < 0;
      
      let deltas = this._getScaledDeltas(he);
      if (doPanLeft)  {
        deltas.x = this._modifyDeltaForPanLeft(deltas.x);  
      }
      if (doPanRight) {
        deltas.x = this._modifyDeltaForPanRight(deltas.x);
      }
      if (doPanDown) {
        deltas.y = this._modifyDeltaForPanDown(deltas.y)
      }
      if (doPanUp) {
        deltas.y = this._modifyDeltaForPanUp(deltas.y)
      }
      
      this._move(deltas);
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/slide-main-pan-listeners.mixin.js